import {
  FavoritesEditContext,
  FavoritesEditConsumer,
  FavoritesEditProvider
} from './favorites-edit-context';

export { FavoritesEditContext, FavoritesEditConsumer, FavoritesEditProvider };

export default FavoritesEditContext;
